import React from 'react';
import Modal from 'react-modal';
import LoadingSpinner from './LoadingSpinner';

Modal.setAppElement('body');

export default function ProcessInformationScreen(): React.JSX.Element {
  return (
    <Modal
      className='fixed inset-0 flex items-center justify-center'
      overlayClassName='fixed inset-0'
      isOpen={true}
      style={{
        content: {
          border: 'none',
        },
        overlay: {
          zIndex: '99999',
          backgroundColor: 'rgba(0,0,0,0.2)',
        },
      }}
    >
      <LoadingSpinner />
    </Modal>
  );
}
